module.exports = __webpack_public_path__ + "static/chat.ba78bd01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/chat.jpg
// module id = 344
// module chunks = 35783957827783